import {
  GET_CURRENT_PLAN_TABLE_BEGIN, GET_CURRENT_PLAN_TABLE_SUCCESS, GET_CURRENT_PLAN_TABLE_FAILURE,
  INSERT_PLAN_TABLE_DATA, POST_CREATE_PLAN_TABLE_BEGIN, POST_CREATE_PLAN_TABLE_SUCCESS, POST_CREATE_PLAN_TABLE_FAILURE,
  PUT_UPDATE_PLAN_TABLE_BEGIN, PUT_UPDATE_PLAN_TABLE_SUCCESS, PUT_UPDATE_PLAN_TABLE_FAILURE,
  GET_PLAN_TABLES_BEGIN, GET_PLAN_TABLES_SUCCESS, GET_PLAN_TABLES_FAILURE,
  POST_ADD_PLAN_BEGIN, POST_ADD_PLAN_SUCCESS, POST_ADD_PLAN_FAILURE,
  CLEAR_CURRENT_PLAN_TABLE_INFO,
  CLEAR_ADDED_PLANS
} from './../constants/ActionTypes'

const initialState = {
  currentTable: null,
  currentTableError: null,
  loadingCurrentTable: false,

  cachedPlanTable: null,

  createdPlanTableInfo: null,
  createdPlanTableError: null,
  creatingPlanTable: false,

  updatedPlanTableInfo: null,
  updatedPlanTableError: null,
  updatingPlanTable: false,

  planTables: [],
  planTablesError: null,
  loadingPlanTables: false,

  addedPlans: [],
  addPlansError: null,
  addingPlans: false
}

const ReducerPlanTable = (state = initialState, { payload, type }) => {
  switch (type) {
    case GET_CURRENT_PLAN_TABLE_BEGIN: {
      return {
        ...state,
        loadingCurrentTable: true,
        currentTableError: null,
        currentTable: null
      }
    }
    case GET_CURRENT_PLAN_TABLE_SUCCESS: {
      return {
        ...state,
        loadingCurrentTable: false,
        currentTableError: null,
        currentTable: payload.response
      }
    }
    case GET_CURRENT_PLAN_TABLE_FAILURE: {
      return {
        ...state,
        loadingCurrentTable: false,
        currentTableError: payload,
        currentTable: null
      }
    }

    case GET_PLAN_TABLES_BEGIN: {
      return {
        ...state,
        planTables: [],
        planTablesError: null,
        loadingPlanTables: true,
      }
    }
    case GET_PLAN_TABLES_SUCCESS: {
      return {
        ...state,
        planTables: payload.response,
        planTablesError: null,
        loadingPlanTables: false,
      }
    }
    case GET_PLAN_TABLES_FAILURE: {
      return {
        ...state,
        planTables: [],
        planTablesError: payload,
        loadingPlanTables: false,
      }
    }

    case INSERT_PLAN_TABLE_DATA: {
      return {
        ...state,
        cachedPlanTable: payload
      }
    }

    case POST_CREATE_PLAN_TABLE_BEGIN: {
      return {
        ...state,
        creatingPlanTable: true,
        createdPlanTableError: null,
        createdPlanTableInfo: null
      }
    }
    case POST_CREATE_PLAN_TABLE_SUCCESS: {

      return {
        ...state,
        creatingPlanTable: false,
        createdPlanTableError: null,
        createdPlanTableInfo: payload.response
      }
    }
    case POST_CREATE_PLAN_TABLE_FAILURE: {
      return {
        ...state,
        creatingPlanTable: false,
        createdPlanTableError: payload.data,
        createdPlanTableInfo: null
      }
    }

    case PUT_UPDATE_PLAN_TABLE_BEGIN: {
      return {
        ...state,
        updatingPlanTable: true,
        updatedPlanTableError: null,
        updatedPlanTableInfo: null
      }
    }
    case PUT_UPDATE_PLAN_TABLE_SUCCESS: {

      return {
        ...state,
        updatingPlanTable: false,
        updatedPlanTableError: null,
        updatedPlanTableInfo: payload.response
      }
    }
    case PUT_UPDATE_PLAN_TABLE_FAILURE: {
      return {
        ...state,
        updatingPlanTable: false,
        updatedPlanTableError: payload.data,
        updatedPlanTableInfo: null
      }
    }

    case POST_ADD_PLAN_BEGIN: {
      return {
        ...state,
        addingPlans: true,
        addPlansError: null,
      }
    }
    case POST_ADD_PLAN_SUCCESS: {

      return {
        ...state,
        addingPlans: false,
        addPlansError: null,
        addedPlans: [...state.addedPlans, payload.response]
      }
    }
    case POST_ADD_PLAN_FAILURE: {
      return {
        ...state,
        addingPlans: false,
        addPlansError: payload.data
      }
    }

    case CLEAR_CURRENT_PLAN_TABLE_INFO: {
      return {
        ...state,
        currentTable: null,
        currentTableError: null,
        loadingCurrentTable: false
      }
    }

    case CLEAR_ADDED_PLANS: {
      return {
        ...state,
        addedPlans: [],
        addPlansError: null,
        addingPlans: false
      }
    }

    default: return state
  }
}

export default ReducerPlanTable